const UserInfo = {
    info: localStorage.UserInfo ? JSON.parse(localStorage.UserInfo) : null,
    token: localStorage.token,
    get(k) {
        if (this.info) {
            return this.info[k];
        } else {
            return false;
        }
    }
}

export default UserInfo;